import type { BonePoseMap, EvidenceNotes, PoseMuscle, YogaPose } from '../types'
import { MUSCLE_CATALOG } from '../muscles/catalog'

export function bones(map: BonePoseMap): BonePoseMap {
  return map
}

export function m(
  id: keyof typeof MUSCLE_CATALOG,
  role: PoseMuscle['role'],
  side: PoseMuscle['side'] = 'both',
): PoseMuscle {
  const def = MUSCLE_CATALOG[id]
  return {
    id: def.id,
    name: def.name,
    role,
    side,
    hasMesh: def.hasMesh,
  }
}

export const defaultEvidence = (
  visible: string,
  plausible: string,
  research: { text: string; url: string }[] = [],
  unknown = 'Individual EMG patterns vary widely; treat highlights as teaching approximations.',
): EvidenceNotes => ({
  visibleAnatomy: visible,
  plausibleMechanisms: plausible,
  researchSupported: research,
  unknown,
})

export const defaultTiming = { entry: 3, hold: 6, release: 3 }

export function pose(p: YogaPose): YogaPose {
  return p
}
